const NODE_ENV = process.env.NODE_ENV;

export const baseUrl = (() => {
  switch (NODE_ENV) {
    case 'production':
      return '//wxgj-api.xdf.cn';
    case 'staging':
      return '//nsale-wx-manager-webapp-test1.test.xdf.cn';
    default:
      // 为啥用带域名的地址：这个值会作为baseURL配置，如果都用相对地址，则会叠加，这并非想要的状态
      return `//${window.location.host}/default-api`;
  }
})();

export const baseUrlForYapi = (() => {
  switch (NODE_ENV) {
    case 'production':
      return '//wxgj-api.xdf.cn';
    case 'staging':
      return '//wxgj-api.test.xdf.cn';
    default:
      return '//capi.staff.xdf.cn/mock/57';
  }
})();

export const opapiUrl = (() => {
  switch (NODE_ENV) {
    case 'production':
      return '//opapi.xdf.cn';
    case 'staging':
      return '//opapi.test.xdf.cn';
    default:
      // 电商支持跨域，不需要反向代理
      return '//opapi.test.xdf.cn';
  }
})();

/** 公众号图文 */
export const wxArticleUrl = (() => {
  switch (NODE_ENV) {
    case 'production':
      return '//zsapi-wx-article.staff.xdf.cn';
    case 'staging':
      return '//nhdm-zs-wx-article-service-test1.test.xdf.cn';
    default:
      return `//${window.location.host}/wx-artical-api`;
  }
})();

/** 智能小编 */

export const aiWriterUrl = (() => {
  switch (NODE_ENV) {
    case 'production':
      return '//chat-api.staff.xdf.cn';
    case 'staging':
      return '//nzhaosh-xdf-chat-test1.test.xdf.cn';
    default:
      return '//nzhaosh-xdf-chat-test1.test.xdf.cn';
  }
})();
